export default __webpack_public_path__ + "static/media/unist_logo2.01b3e428.svg";